<template>
  <v-card
    class="subscription-alert-card"
    flat
    :style="{ top: `${top}px` }"
    :dark="darkMode"
  >
    <v-card-text class="pa-5">
      <div v-if="isDemoUser" class="subscription-alert-title">
        Demonstration Mode — Restricted Functionality
      </div>
      <div v-if="isDemoUser" class="subscription-alert-body">
        This is a product demonstration session.
        <br />
        Some features are unavailable.
        <br />
        <br />
        Sign in or create an account to continue with full access.
      </div>
      <div v-else class="subscription-alert-body">
        <slot>
          This session is running in a demonstration environment for product
          evaluation.
          <br />
          Full functionality is not available in this mode.
          <br />
          <br />
          Please sign in or create an account to access the complete system.
        </slot>
      </div>
    </v-card-text>
    <v-card-actions class="subscription-alert-actions-wrap">
      <div class="d-flex ml-auto subscription-alert-actions">
        <v-btn
          color="primary"
          class="subscription-alert-btn-primary"
          @click="createAccountFromHere"
        >
          CREATE FREE ACCOUNT
        </v-btn>
        <v-btn
          text
          color="accent"
          class="subscription-alert-btn-secondary"
          @click="loginFromHere"
        >
          Sign In
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SubscriptionAlert",
  props: {
    top: { default: 0, type: Number }
  },
  computed: {
    ...mapGetters(["darkMode"]),
    ...mapGetters("auth", ["isAuth"]),
    isDemoUser() {
      return Boolean(this.$store.state.auth.user?.is_demo);
    }
  },
  methods: {
    async createAccountFromHere() {
      if (this.isAuth) {
        try {
          await this.$store.dispatch("auth/logout");
        } finally {
          this.$router.push("/register").catch(() => {});
        }
        return;
      }
      this.$router.push("/register").catch(() => {});
    },
    async loginFromHere() {
      if (this.isAuth) {
        try {
          await this.$store.dispatch("auth/logout");
        } finally {
          this.$router.push("/login").catch(() => {});
        }
        return;
      }
      this.$router.push("/login").catch(() => {});
    }
  }
};
</script>

<style scoped>
.subscription-alert-card {
  min-width: 380px;
  max-width: 520px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  text-align: left;
}
.subscription-alert-card.theme--dark {
  background: #141414;
}
.subscription-alert-card.theme--light {
  background: #ffffff;
  border-color: rgba(0, 0, 0, 0.14);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}
.subscription-alert-title {
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.35;
  margin-bottom: 10px;
}
.subscription-alert-body {
  line-height: 1.45;
  font-size: 0.96rem;
}
.subscription-alert-actions-wrap {
  padding: 0 20px 20px;
}
.subscription-alert-actions {
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.subscription-alert-btn-primary {
  min-width: 156px;
  border-radius: 8px;
}
.subscription-alert-btn-secondary {
  min-width: 96px;
  border-radius: 8px;
}
</style>
